import React, { useContext, useEffect, useState, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { FirebaseContext } from '../../context/firebase';
import defaultUser from '../../assets/defaultUser.png';
import styles from './Profile.module.scss';
import {
	Grid,
	makeStyles,
	Paper,
	Snackbar,
	TextField,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { Edit } from '@material-ui/icons';
import CustomButton from '../layout/customButton/CustomButton';
import saveProfile from '../../api/Profile/saveProfile.api';
import { humanizer } from '../../utils/snakeCaseToHumanize';
import CameraAltIcon from '@material-ui/icons/CameraAlt';
import getProfileData from '../../api/Profile/getProfileData.api';
import * as PROJECT_CODE from '../../constants/projectCode';
import { useProfileStyles } from '../../muiStyles/Profile.mui';
import PersonalCard from './PersonalCard';
import CompanyCard from './CompanyCard';
import Alert from '@material-ui/lab/Alert';
import {
	reformatPhoneString,
	removeAlphabeticalCharWithMaxLength,
	validatePhoneNumber,
} from '../../utils/validatePhoneNumber';

import { editProfile, getProfile } from '../../redux/profile/action';
import CustomAlerts from '../alerts/CustomAlerts';
import CustomizedZendesk from '../CustomizedZendesk/CustomizedZendesk';
import { setLocation } from '../../redux/location/action';
import { useLocation } from 'react-router';

const Profile = ({
	user,
	profileData,
	loading,
	getProfile,
	editProfile,
	rolesAccessibilities,
	setLocation,
}) => {
	const [edit, setEdit] = useState(false);
	const [editCompany, setEditCompany] = useState(false);
	const [formData, setFormData] = useState({
		fullName: profileData?.fullName,
		email: profileData?.email,
		phoneNumber: profileData?.phoneNumber,
		companyName: profileData?.companyName,
	});
	const { fullName, email, phoneNumber, companyName } = formData;
	const [error, setError] = useState('');
	const [success, setSuccess] = useState('');
	const [overlay, setOverlay] = useState(false);
	const [overlayCompany, setOverlayCompany] = useState(false);
	const inputFile = useRef(null);
	const inputFileCompany = useRef(null);
	const [profileImage, setProfileImage] = useState();
	const [profileImageCompany, setProfileImageCompany] = useState();
	const [previewImage, setPreviewImage] = useState();
	const [previewImageCompany, setPreviewImageCompany] = useState();
	const [snackbar, setSnackbar] = useState(false);
	const location = useLocation();

	const onChange = (e) => {
		let value = e.target.value;
		if (e.target.name === 'phoneNumber') {
			let phoneNum = removeAlphabeticalCharWithMaxLength(value);
			if (validatePhoneNumber(phoneNum)) {
				value = reformatPhoneString(phoneNum);
			} else {
				value = phoneNum;
			}
		}
		setFormData({ ...formData, [e.target.name]: value });
	};

	useEffect(() => {
		getProfile();
		let currentLocation = location.pathname.split('/')[1];
		setLocation(currentLocation);
	}, []);

	useEffect(() => {
		return () => {
			setLocation('');
		};
	}, []);

	useEffect(async () => {
		setFormData({
			fullName: profileData?.fullName,
			email: profileData?.email,
			phoneNumber: profileData?.phoneNumber,
			companyName: profileData?.companyName,
		});
	}, [profileData]);

	const handleClickEdit = () => {
		setEdit(true);

		//get data from db. Data that needs to be edited
		setFormData({
			fullName: profileData.fullName,
			email: profileData.email,
			phoneNumber: profileData.phoneNumber,
			companyName: profileData.companyName,
		});
	};

	const handleClickEditCompany = () => {
		setEditCompany(true);
		//get data from db. Data that needs to be edited
	};

	const handleEdit = (e) => {
		console.log('handleEdit');
		setEdit(false);
		setPreviewImage();
		if (
			fullName === '' ||
			email === '' ||
			!fullName.replace(/\s/g, '').length ||
			!email.replace(/\s/g, '').length
		) {
			setError('The fields cannot be empty');
			setSnackbar(true);
			setTimeout(() => {
				setError('');
			}, 4500);
		} else {
			console.log('Profile Data uidjojoj', user.uid);
			editProfile(
				'personal',
				fullName,
				email,
				phoneNumber,
				companyName,
				user.uid,
				profileImage,
				profileImageCompany
			).then(() => {
				setSuccess('Edit Profile successfully.');
				setSnackbar(true);
				setTimeout(() => setSuccess(''), 3000);
			});
		}
	};

	const handleEditCompany = (e) => {
		setEditCompany(false);
		setPreviewImageCompany();
		if (
			fullName === '' ||
			email === '' ||
			!companyName.replace(/\s/g, '').length
		) {
			setError('Please fill in all the fields.');
			setSnackbar(true);
			setTimeout(() => setError(''), 3000);
		} else {
			editProfile(
				'company',
				fullName,
				email,
				phoneNumber,
				companyName,
				user.uid,
				profileImage,
				profileImageCompany
			);
			setSuccess('Edit Profile successfully.');
			setSnackbar(true);
			setTimeout(() => setSuccess(''), 3000);
		}
	};

	const onOverlayClick = () => {
		inputFile.current.click();
	};
	const onOverlayClickCompany = () => {
		inputFileCompany.current.click();
	};

	const onChangeImage = (e) => {
		var imgType = e.target.files[0].type;

		if (
			imgType === 'image/png' ||
			imgType === 'image/jpeg' ||
			imgType === 'image/jpg' ||
			imgType === 'image/gif'
		) {
			setProfileImage(e.target.files[0]);
			setPreviewImage(URL.createObjectURL(e.target.files[0]));
		} else {
			setError(
				'Please choose only files with extension .png, jpeg, .jpg or .gif'
			);
			setTimeout(() => {
				setError('');
			}, 4500);
		}
	};

	const onChangeImageCompany = (e) => {
		var imgType = e.target.files[0].type;
		if (
			imgType === 'image/png' ||
			imgType === 'image/jpeg' ||
			imgType === 'image/jpg' ||
			imgType === 'image/gif'
		) {
			setProfileImageCompany(e.target.files[0]);
			setPreviewImageCompany(URL.createObjectURL(e.target.files[0]));
		} else {
			setError(
				'Please choose only files with extension .png, jpeg, .jpg or .gif'
			);
			setTimeout(() => {
				setError('');
			}, 4500);
		}
	};

	const classes = useProfileStyles();

	// useEffect(() => {
	// 	console.log('locationvasf');

	// 	setLocation(location.pathname.split('/')[0]);
	// 	return () => {
	// 		setLocation();
	// 	};
	// }, []);

	return (
		<div className={styles.profile_page}>
			<p className={styles.profile_title}>Profile</p>
			{/* <CustomizedZendesk /> */}

			<hr className={styles.separator} />

			{error && (
				<CustomAlerts
					alertType={'error'}
					alertMsg={error}
					snackbar={snackbar}
					setSnackbar={setSnackbar}
				/>
			)}

			{success && (
				<CustomAlerts
					alertType={'success'}
					alertMsg={success}
					snackbar={snackbar}
					setSnackbar={setSnackbar}
				/>
			)}

			<Grid className={styles.card_group} container>
				<PersonalCard
					styles={styles}
					edit={edit}
					previewImage={previewImage}
					handleEdit={handleEdit}
					handleClickEdit={handleClickEdit}
					setOverlay={setOverlay}
					profileData={profileData}
					overlay={overlay}
					onOverlayClick={onOverlayClick}
					inputFile={inputFile}
					onChangeImage={onChangeImage}
					onChange={onChange}
					classes={classes}
					fullName={fullName}
					email={email}
					phoneNumber={phoneNumber}
					user={user}
					rolesAccessibilities={rolesAccessibilities}
				/>

				<CompanyCard
					styles={styles}
					classes={classes}
					companyName={companyName}
					onChange={onChange}
					editCompany={editCompany}
					inputFileCompany={inputFileCompany}
					previewImageCompany={previewImageCompany}
					onChangeImageCompany={onChangeImageCompany}
					handleEditCompany={handleEditCompany}
					handleClickEditCompany={handleClickEditCompany}
					setOverlayCompany={setOverlayCompany}
					overlayCompany={overlayCompany}
					profileData={profileData}
					user={user}
					onOverlayClickCompany={onOverlayClickCompany}
					rolesAccessibilities={rolesAccessibilities}
				/>
			</Grid>
		</div>
	);
};

const mapStateToProps = (state) => ({
	user: state.signIn,
	profileData: state.profile.profileInfo,
	loading: state.profile.profileInfo.loading,
	rolesAccessibilities: state.userManagement.rolesAccessibilities,
});

export default connect(mapStateToProps, {
	getProfile,
	editProfile,
	setLocation,
})(Profile);
